import { constants } from "../../../constants";

export default class WonAmountChange {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    SSG_handler(payload) {
        if (payload && payload.data && payload.data.winAmount) {
            this.gb.emitters.emit.web.wonAmountChange({payload: { winAmount: payload.data.winAmount}});
        }
    }
    WZD_handler(payload) {
        if (payload && payload.param && payload.param.win) {
            this.gb.emitters.emit.web.wonAmountChange({payload: { winAmount: payload.param.win}});
        }
    }

    SPIN_handler(payload) {
        this.gb.emitters.emit.web.wonAmountChange({payload: { winAmount: payload.win || 0}});
        this.gb.emitters.emit.web.balanceChange(payload.balance);
    }

    _default(data) {
        if(this.gb.api && this.gb.api.modules && this.gb.api.modules.superWheel.instanceAvailable) {
            this.gb.wonAmount = data.payload.winAmount;
        }
        this.gb.emitters.emit.web.wonAmountChange(data);
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.gameProviderProtocol) {
            case constants.SPIN:
                event["round_result"] = this.SPIN_handler;
                break;
            case constants.SSG:
                event["wonAmount"] = this.SSG_handler;
                break;
            case constants.WZD:
                event["wonAmount"] = this.WZD_handler;
                event["wonAmount.parent"] = this.WZD_handler;
                break;
            default:
                event["wonAmount"] = this._default;
        }

        return event;
    }
}
